import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import { compareSort } from '@/vue-dlb/common/common';
import api from '@/vue-dlb/utils/setup-api';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';
const baseURI = config.setupApiUrl;

const workflowGroupStoreModule = {
  state: {
    workflowGroup: [],
    workflowGroupList: [],
    workflowGroupSelectBoxList: [],
    workflowGroupDtlList: [],
    workflowGroupListPaging: [],
    workflowGroupListSource: [],
    workflowGroupListFilter: [],
    workflowGroupChange: {},
  },
  mutations: {
    SET_STORE_WORKFLOW_GROUP_LIST(state, workflowGroupList) {
      if (
        JSON.stringify(state.workflowGroupListSource) !== JSON.stringify(workflowGroupList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('GRP');
      }
      state.workflowGroupList = workflowGroupList;
      state.workflowGroupListPaging = [...workflowGroupList];
      state.workflowGroupListSource = [...workflowGroupList];
    },
    SET_STORE_WORKFLOW_GROUP_SELECT_BOX_LIST(state, workflowGroupSelectBoxList) {
      state.workflowGroupChange = compareTableData(
        state.workflowGroupSelectBoxList,
        workflowGroupSelectBoxList,
        'id'
      );
      state.workflowGroupSelectBoxList = workflowGroupSelectBoxList.map((item) => {
        return {
          ...item,
          text: item.procNm,
          value: item.id,
        };
      });
    },

    SET_STORE_WORKFLOW_GROUP_ID(state, id) {
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('GRP');
      }
    },
    SET_STORE_WORKFLOW_GROUP_DETAIL_LIST(state, workflowGroupDtlList) {
      state.workflowGroupDtlList = workflowGroupDtlList;
    },
    SET_STORE_WORKFLOW_GROUP_LIST_PAGING(state, paging) {
      let datarows = [...state.workflowGroupListSource];
      state.workflowGroupList = datarows.slice(paging.startIndex, paging.endIndex);
      state.workflowGroupListPaging = [...state.workflowGroupList];
    },
    SET_STORE_WORKFLOW_GROUP_LIST_FILTER_PAGING(state, paging) {
      let datarows = state.workflowGroupList;
      state.workflowGroupList = datarows.slice(paging.startIndex, paging.endIndex);
      state.workflowGroupListPaging = [...state.workflowGroupList];
    },
    SET_STORE_WORKFLOW_GROUP_LIST_FILTER(state, filter) {
      let datarows = [...state.workflowGroupListSource];
      state.filter = filter;
      let filterBy = state.filter;
      let arrFilter = [];
      if (filterBy != null) {
        let filter = filterBy.filter;
        let strSearch = filterBy.strSearch;
        if (strSearch.trim() == '') {
          arrFilter = datarows;
        }
        arrFilter = datarows.filter((item) => {
          if (filter == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = strSearch.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = strSearch.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[filter] == 'string') {
              let propValue = item[filter].toLowerCase();
              let queryValue = strSearch.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[filter] == 'number') {
              let propValue = item[filter].toString().toLowerCase();
              let queryValue = strSearch.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        });
      }
      state.workflowGroupList = arrFilter;
      state.workflowGroupListFilter = [...arrFilter];
    },
    SET_STORE_WORKFLOW_GROUP_LIST_SORT(state, data) {
      let datarows = state.workflowGroupList;
      let { col, sort } = data;
      if (sort === 'reset') {
        state.workflowGroupList = [...state.workflowGroupListPaging];
        if (state.filter && state.filter.strSearch) {
          state.workflowGroupList = [...state.workflowGroupListFilter];
        }
        return;
      }
      datarows.sort((pre, next) => {
        let propPre = pre[col];
        let propNext = next[col];
        return compareSort(propPre, propNext, sort);
      });

      state.workflowGroupList = datarows;
    },
    SET_STORE_WORKFLOW_GROUP(state, id) {
      if (id !== undefined && id !== null && id !== '') {
        const grpProcList = state.workflowGroupList;
        for (let i = 0; i < grpProcList.length; i += 1) {
          const grpProcInfo = grpProcList[i];
          if (grpProcInfo.id === id) {
            state.workflowGroup = JSON.parse(JSON.stringify(grpProcInfo));
            console.log(state.workflowGroup);
            break;
          }
        }
      } else {
        state.workflowGroup = {};
      }
    },
  },
  actions: {
    getWorkflowGroupList: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/workflowGroup/list`, params);
        commit('SET_STORE_WORKFLOW_GROUP_LIST', response.data);
      } catch (err) {
        commit('SET_STORE_WORKFLOW_GROUP_LIST', []);
        throw err;
      }
    },
    getWorkflowGroup: async ({ commit }, params) => {
      try {
        commit('SET_STORE_WORKFLOW_GROUP', params);
      } catch (err) {
        commit('SET_STORE_WORKFLOW_GROUP', null);
        throw err;
      }
    },
    insertWorkflowGroup: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/workflowGroup/insert`, params);
        commit('SET_STORE_WORKFLOW_GROUP_ID', response.data);
        return response.data;
      } catch (err) {
        throw err;
      }
    },
    updateWorkflowGroup: async ({ commit }, params) => {
      try {
        const response = await axios.post(`${baseURI}/workflowGroup/update`, params);
        commit('SET_STORE_WORKFLOW_GROUP_ID', response.data);
      } catch (err) {
        throw err;
      }
    },
    getWorkflowGroupDtlList: async ({ commit }, params) => {
      try {
        const response = await api.postData('workflowGroup/dtl/list', params);
        commit('SET_STORE_WORKFLOW_GROUP_DETAIL_LIST', response.data);
      } catch (err) {
        throw err;
      }
    },
    deleteWorkflowGroup: async ({ commit }, params) => {
      try {
        const response = await api.postData('workflowGroup/delete', params);
        commit('SET_STORE_WORKFLOW_GROUP_ID', response.data);
      } catch (err) {
        throw err;
      }
    },
    getWorkflowGroupSelectBoxList: async ({ commit }, params) => {
      return await axios
        .post(`${baseURI}/workflowGroup/list`, params)
        .then((response) => {
          let data = response.data;
          commit('SET_STORE_WORKFLOW_GROUP_SELECT_BOX_LIST', response.data);
          return data;
        })
        .catch((ex) => {
          commit('SET_STORE_WORKFLOW_GROUP_SELECT_BOX_LIST', []);
          throw ex;
        });
    },
  },
  getters: {
    workflowGroupList: (state) => state.workflowGroupList,
    workflowGroupSelectBoxList: (state) => state.workflowGroupSelectBoxList,
    workflowGroup: (state) => state.workflowGroup,
    workflowGroupDtlList: (state) => state.workflowGroupDtlList,
    workflowGroupChange: (state) => state.workflowGroupChange,
  },
};
export default workflowGroupStoreModule;
